@if(loading$ | async ) {
<app-loading
  class="h-100 w-100 loading-container"
  [text]="'Loading'"
></app-loading>
} @else {
<div class="button-list">
  <button class="release-btn btn-accello-secondary" (click)="addNewUiObject()">
    <img
      [src]="'images/virtusa-icons/add-icon-dark.svg' | assetUrl"
      alt="Add Icon"
      width="18"
      height="18"
    />
    Add New UI Object
  </button>

  <button
    class="release-btn btn-accello-light"
    (click)="removeUiObject()"
    [disabled]="!selectedObjects.length"
    (focus)="changeRemoveIcon(false)"
    (mouseenter)="changeRemoveIcon(false)"
    (mouseleave)="changeRemoveIcon(false)"
    (blur)="changeRemoveIcon(false)"
    (mousedown)="changeRemoveIcon(true)"
    (mouseup)="changeRemoveIcon(false)"
  >
    <img [src]="iconSrcDelete | assetUrl" width="18" height="18" />
    <span>Remove UI Objects</span>
    @if(isLoading){
      <span class="spinner-border spinner-border-sm mx-2" role="status" aria-hidden="true"></span>
    }
  </button>
  <button class="btn-accello-ternary" (click)="refreshData()">
    <img [src]="'images/virtusa-icons/sync.svg' | assetUrl" alt="refresh" />
    <span>Refresh</span>
  </button>
</div>
<div class="d-flex flex-row">
  <div class="page-tab d-flex gap-3">
    <div class="name-div"><span class="accello-general-text2 pg-sp">Page Name</span>
      <span class="accello-general-text13">{{
        page?.name
      }}</span></div>
    <div [hidden]="isMobileType" class="url">
      <span class="accello-general-text2 pg-sp">Page URL</span>

      <span class="accello-general-text13">{{
        page?.url
      }}</span>
      <!-- <span class="general-text d-flex justify-content-center flex-column">https://www.virtusa.com/brand/external/color</span> -->
    </div>
  </div>
</div>
<div class="reusable-wrapper">
<app-zorro-table
  tableId="page-list-tabular"
  [data]="tableData"
  [columns]="columns"
  [options]="{ expandable: true }"
  (handleActions)="handleTableActions($event)"
  (onRowSelect)="handleRowSelect($event)"
></app-zorro-table>
</div>
}
